import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { TaskKind } from './Decoder';

interface Props {
  kind: TaskKind;
}

function TaskDetail({ kind }: Props) {
  switch (kind) {
    case 'add-participants-to-group':
      return <T kind="Add/Import Participants to Groups" />;
    case 'create-learning-collection':
      return <T kind="Create a Learning Collection" />;
    case 'create-user-group':
      return <T kind="Add Groups" />;
    case 'generate-deep-links':
      return <T kind="Generate Program Deep Links for a Learning Collection" />;
    case 'invite-participants':
      return <T kind="Invite Participants to a Program in a Learning Collection" />;
    case 'learning-collection-each-license':
      return <T kind="Create a Learning Collection for Each of Your Product Licenses" />;
    case 'onboard-participants':
      return <T kind="Onboard Participants to a Learning Collection" />;
    case 'publish-learning-collection':
      return <T kind="Publish a Learning Collection" />;
  }
}

export default observer(TaskDetail);
